import React from 'react';
import {motion} from 'framer-motion';
import {FiArrowRight} from 'react-icons/fi';

const Perspective = () => {
  return (
    <section id="perspective" className="py-24 md:py-48 bg-brand-primary relative overflow-hidden">
      {/* Tonal background variation */}
      <div className="absolute inset-0 bg-brand-secondary/5 z-0"></div>
      
      <div className="container mx-auto px-6 md:px-12 relative z-10">
        <div className="mb-20">
          <span className="text-[11px] tracking-[0.4em] uppercase text-brand-accent font-bold">Featured Perspective</span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-32 items-center">
          <motion.div 
            initial={{opacity: 0, scale: 0.98}} 
            whileInView={{opacity: 1, scale: 1}} 
            viewport={{once: true}} 
            transition={{duration: 1.2}} 
            className="relative aspect-[4/3] md:aspect-[16/9] lg:aspect-[4/5] overflow-hidden bg-brand-secondary/20 shadow-[0_30px_60px_rgba(0,0,0,0.4)]"
          >
            {/* Newly uploaded EPOQ Mobility autonomous vehicle image */}
            <img 
              src="https://media-manager-c.questera.ai/greta-media/4948ae8bd3a71eaecd010e3b75a418c9afeda68ebd57283642e35d04cbb3fca3a3104393b4fae87688db585a45c44e03/images/aW1hZ2UvanBlZw==/cb69cb65c925d468167d3902c977065f.jpeg" 
              alt="EPOQ Mobility autonomous transport prototype" 
              className="w-full h-full object-cover opacity-100" 
            />
            {/* Lightened gradient for Mobility feature */}
            <div className="absolute inset-0 bg-gradient-to-t from-brand-primary/30 via-transparent to-transparent"></div>
          </motion.div>

          <motion.div 
            initial={{opacity: 0, y: 30}} 
            whileInView={{opacity: 1, y: 0}} 
            viewport={{once: true}} 
            transition={{duration: 0.8, delay: 0.2}} 
          >
            <h2 className="font-display text-4xl md:text-6xl font-light text-white mb-10 tracking-tight leading-[1.1]">
              Autonomous delivery is moving from concept to reality.
            </h2>
            <div className="space-y-8 mb-14 text-white/90 text-lg md:text-xl font-light leading-relaxed">
              <p>
                EPOQ Mobility is working with autonomous delivery infrastructure to enable next-generation urban logistics.
              </p>
              <p className="text-white/60">
                Our pilot programs in Denmark are testing the practical integration of these systems into existing city networks. More information will follow as the project develops.
              </p>
            </div>
            <a 
              href="https://epoqmobility.com/" 
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center text-[13px] tracking-[0.25em] uppercase text-white font-bold hover:text-brand-accent transition-colors group"
            >
              <span className="mr-5 border-b-2 border-white/30 pb-1 group-hover:border-brand-accent transition-all">Discover EPOQ Mobility</span>
              <FiArrowRight className="text-xl transform group-hover:translate-x-3 transition-transform duration-500" />
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Perspective;